import React from 'react';
import { Helmet } from 'react-helmet-async';
import { MINI_APPS } from '@/types/miniApp';
import { MiniAppCard } from '@/components/mini-apps/MiniAppCard';
import { useTranslation } from 'react-i18next';
import { Smartphone } from 'lucide-react';

const MiniAppsPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>Mini Apps - Trade Bot 365</title>
        <meta name="description" content="Access your trading platforms and tools" />
      </Helmet>

        <div className="space-y-6 max-w-6xl mx-auto">
        <div className="flex items-center gap-3 mb-6">
          <div className="p-3 rounded-xl bg-gradient-to-br from-primary/20 to-primary/10">
            <Smartphone className="w-6 h-6 text-primary" />
          </div>
          <div>
            <h1 className="text-xl sm:text-2xl md:text-3xl font-bold bg-gradient-to-r from-foreground to-foreground/70 bg-clip-text text-transparent">
              Mini Apps
            </h1>
            <p className="text-sm md:text-base text-muted-foreground mt-1">
              Quick access to your trading platforms and tools
            </p>
          </div>
        </div>

        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-6 sm:gap-8 justify-items-center mx-auto">
          {MINI_APPS.map(app => (
            <MiniAppCard key={app.id} app={app} />
          ))}
        </div>

      </div>
    </>
  );
};

export default MiniAppsPage;
